import React, { FC, useCallback, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import cn from 'classnames';
import styles from './styles.module.scss';
import { Button, Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import { StepContext } from '../../../../../creator/step.context';

type DesktopSubmitViewProps = React.ComponentPropsWithoutRef<'div'> & {
    nextBtnText?: string;
};

export const DesktopSubmitView: FC<DesktopSubmitViewProps> = (props) => {
    const { nextBtnText } = props;
    const form = useFormContext();
    const isMobile = useIsMobile();
    const { nextStep } = useContext(StepContext);

    const {
        formState: { dirtyFields: _, errors },
        trigger,
    } = form;

    const onClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
        async (event) => {
            const isValid = await trigger();
            if (!isValid) {
                return event.preventDefault();
            }
            if (isMobile) {
                nextStep();
            }
        },
        [trigger, isMobile, nextStep],
    );

    const isDisabled = Object.keys(errors).length > 0;

    return (
        <div className={cn(styles['submit-row'])}>
            <Button
                type={isMobile ? 'button' : 'submit'}
                variant="primary"
                size={52}
                className={styles['submit-row__btn']}
                disabled={isDisabled}
                onClick={onClick}>
                {nextBtnText || 'Далее'}
                <Icon icon={<ArrowRight />} strong />
            </Button>
        </div>
    );
};
